// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:06.051Z
// Property: Park at Mission Hills (ID: 6767906449167043)
// Collections: 35 amenities, 6 floorplans (live), 30 photos, 67 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167043",
  "property_external_id": "48288",
  "property_zillow_url": "https://www.zillow.com/apartments/broken-arrow-ok/park-at-mission-hills/5XhzVF/",
  "property_apartments_url": "https://www.apartments.com/2700-n-7th-st-broken-arrow-ok-unit-333/15g1db6/",
  "property_google_business_url": "https://www.google.com/maps/place/Park+at+Mission+Hills/data=!4m2!3m1!1s0x0:0x63ffd7447dd7ab07?sa=X&ved=2ahUKEwjomeCzh4OTAxW7w8kDHYlkKooQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-at-mission-hills",
  "property_name": "Park at Mission Hills",
  "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/park-at-mission-hills/",
  "property_domain": null,
  "property_address": "2700 N. 7th Street",
  "property_full_address": "2700 N. 7th Street, Broken Arrow, OK, 74012",
  "property_address_1": "2700 N. 7th Street",
  "property_address_2": null,
  "property_address_city": "Broken Arrow",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74012",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": null,
  "property_address_latitude": "36.0777",
  "property_address_longitude": "-95.7843",
  "property_email": "missionhills@caseusa.com",
  "property_phone": "(539) 269-1171",
  "property_call_tracking_phone": "833-330-3539",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Park at Mission Hills, your serene retreat in Broken Arrow, OK. Choose from spacious one or two-bedroom floor plans with modern amenities like 24-hour fitness centers, resort-style pools, and relaxing ponds. Pet-friendly and equipped for comfort, it’s where home meets lifestyle. Schedule your tour and find your new haven today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Park at Mission Hills** – your ultimate living destination in Broken Arrow, OK! Our vibrant apartment community offers spacious one and two-bedroom floor plans designed to accommodate your lifestyle. Experience unparalleled convenience with washer and dryer connections, central heat and air conditioning, and modern amenities like a microwave and dishwasher. Enjoy the comfort of large closets, cable-ready living spaces, and the charm of select apartments featuring cozy fireplaces or private patios/balconies.\n\nAt Park at Mission Hills, we understand that home is where your heart is, including your furry friends! Our pet-friendly community features an onsite bark park, allowing your pets to roam freely while you unwind by our relaxing pond or in the beautifully landscaped courtyard.\n\nStay active and connected with our two 24-hour fitness centers, inspiring clubhouse, and two resort-style pools complete with inviting sundecks. For those working from home or needing a quiet study space, our two state-of-the-art business centers are at your disposal. \n\nWe prioritize your convenience and security with limited-access gates, onsite management, and maintenance services, including package receiving. Plus, we offer flexible payment options and electronic payment acceptance for a hassle-free living experience.\n\nDiscover a community that feels like home—filled with amenities that support your lifestyle. Ready to make the move? **Find your new home today** by browsing our availability or scheduling a tour to visit Park at Mission Hills. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019dbbe9-f8f2-725a-a972-d473b508b5ea.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment buildings surrounding a lake with fountains and a pool area.",
    "public_id": "019dbbe9-f8f2-725a-a972-d473b508b5ea",
    "storage_key": "property/6767906449167043/019dbbe9-f8f2-725a-a972-d473b508b5ea.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "39",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": "75",
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions Apply",
  "property_pet_policy_description": "Pets Welcome",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://parkatmissionhillsapartmentsbrokenarrow.securecafe.com/onlineleasing/park-at-mission-hills-0/floorplans.aspx",
  "property_resident_portal_url": "https://parkatmissionhillsapartmentsbrokenarrow.securecafe.com/residentservices/park-at-mission-hills-0/userlogin.aspx",
  "property_apply_now_url": "https://parkatmissionhillsapartmentsbrokenarrow.securecafe.com/onlineleasing/park-at-mission-hills-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-52ad-73e3-9ee0-a17fc64d4722.webp",
  "property_primary_logo_media": {
    "alt_text": "The Park at Mission Hills logo.",
    "public_id": "019cfb52-52ad-73e3-9ee0-a17fc64d4722",
    "storage_key": "property/6767906449167043/019cfb52-52ad-73e3-9ee0-a17fc64d4722.webp",
    "width": 330,
    "height": 160
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb53-6c24-73be-9a4c-710b5889db13.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Park at Mission Hills logo",
    "public_id": "019cfb53-6c24-73be-9a4c-710b5889db13",
    "storage_key": "property/6767906449167043/019cfb53-6c24-73be-9a4c-710b5889db13.webp",
    "width": 330,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb53-7405-75cb-8e47-02de3e8eac5b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Park at Mission Hills logo",
    "public_id": "019cfb53-7405-75cb-8e47-02de3e8eac5b",
    "storage_key": "property/6767906449167043/019cfb53-7405-75cb-8e47-02de3e8eac5b.webp",
    "width": 330,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#827466",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1176",
  "property_sqft_min": "789",
  "property_sqft_max": "1176",
  "property_price_range": "1099 - 1609",
  "property_price_min": "1099",
  "property_price_max": "1609",
  "property_available_units": 15,
  "property_facebook_url": "https://m.facebook.com/ParkAtMissionHillsBrokenArrow/photos/?locale=hi_IN",
  "property_instagram_url": "https://www.instagram.com/theparkatmissionhills/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2XCUAKaLtocRB6vXfUTX_2M",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Tulsa%2C+OK&start=60",
  "property_tiktok_url": "https://www.tiktok.com/@parkmissionhills",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park at Mission Hills",
  "property_home_romance_title": "Find Your Haven of Love and Comfort Today",
  "property_home_amenities_blurb": "Welcome to Park at Mission Hills in Broken Arrow, OK, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans, complete with modern amenities. Enjoy pet-friendly living, serene views by the pond, resort-style pools, and 24-hour fitness centers for a lifestyle that elevates everyday living. Explore your new home today!",
  "property_home_floorplans_blurb": "At Park at Mission Hills in Broken Arrow, OK, our thoughtfully designed floor plans cater to your lifestyle needs. Experience vibrant community living amidst beautiful landscapes and modern amenities. Browse our available apartment homes today and uncover the ideal space that truly feels like home. Your sanctuary awaits!",
  "property_home_gallery_blurb": "At Park at Mission Hills in Broken Arrow, OK, comfort meets convenience. With energy-efficient appliances, spacious layouts, and pet-friendly amenities like a relaxing pond and onsite bark park, your ideal home awaits. Imagine evenings by the grill or soaking up the sun by the pool—picture yourself living here!",
  "property_home_neighborhood_blurb": "At Park at Mission Hills in Broken Arrow, OK, you'll find expansive one- and two-bedroom floor plans nestled among vibrant local attractions. From the tranquility of Rhema Park to the excitement of Sky Zone Trampoline Park, your new home is a stone's throw from leisure and learning, including Tulsa Community College and Northeastern State University.",
  "property_home_reviews_blurb": "Welcome to Park at Mission Hills in Broken Arrow, OK, where our residents rave about the \"serene atmosphere and friendly neighbors.\" Experience a community that feels like home. See what our residents have to say about living at our community and join the vibrant lifestyle waiting for you!",
  "property_neighborhood_blurb": "At Park at Mission Hills in Broken Arrow, OK, your vibrant lifestyle awaits amid a tapestry of convenience and adventure. With top-tier educational institutions like Tulsa Community College and Northeastern State University just moments away, plus serene parks and premier fitness centers, you'll love every facet of your new home. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Park at Mission Hills in Broken Arrow, OK, your perfect home awaits with delightful one- and two-bedroom floor plans. Enjoy life’s little luxuries, from our pet-friendly bark park and serene pond to two resort-style pools and cutting-edge fitness centers. Embrace comfort and convenience with features that cater to your lifestyle.",
  "property_applynow_blurb": "At Park at Mission Hills in Broken Arrow, OK, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, and enjoy our pet-friendly amenities, including relaxing ponds, vibrant pools, and a dedicated bark park. Ready to elevate your lifestyle? Lease online today and make it yours!",
  "property_contactus_blurb": "Nestled in the heart of Broken Arrow, OK, Park at Mission Hills offers thoughtfully designed one and two-bedroom apartments that cater to your lifestyle. With spacious floor plans and modern amenities, your dream home awaits. Have questions? Contact our leasing team today and let us help you find the perfect fit!",
  "property_faqs_blurb": "At Park at Mission Hills in Broken Arrow, OK, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Curious about our community? Visit our FAQs page for insights into amenities, policies, and more, making your decision easier and your living experience exceptional.",
  "property_floorplans_blurb": "At Park at Mission Hills in Broken Arrow, OK, your ideal living space awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, each crafted with your comfort in mind. Browse our available apartment homes today and envision the lifestyle you've always wanted!",
  "property_gallery_blurb": "Immerse yourself in the vibrant lifestyle at Park at Mission Hills in Broken Arrow, OK. Picture your days by the serene pond, enjoying endless amenities like two resort-style pools and a pet-friendly bark park. Explore spacious floor plans designed for comfort, all while nestled in a welcoming community. ",
  "property_interactivemap_blurb": "At Park at Mission Hills in Broken Arrow, OK, your ideal living experience awaits. Choose from spacious one- and two-bedroom floor plans, featuring modern amenities like resort-style pools, a relaxing pond, and a pet-friendly bark park. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Park at Mission Hills in Broken Arrow, OK, your furry friends are part of the family. Enjoy spacious apartments just moments away from lush parks and vibrant local spots. Embrace a lifestyle of comfort and community—where both you and your pets can thrive together in perfect harmony.",
  "property_referafriend_blurb": "At Park at Mission Hills in Broken Arrow, OK, our cozy one and two-bedroom apartments redefine comfort and style. With spacious layouts tailored for modern living, you'll enjoy both privacy and community. Great friends make great neighbors—refer a friend and elevate your living experience today!",
  "property_residentaccess_blurb": "At Park at Mission Hills in Broken Arrow, OK, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and unlock the full potential of your living experience. Your comfort and convenience are just a click away!",
  "property_reviews_blurb": "At Park at Mission Hills in Broken Arrow, OK, residents rave about their experience, stating, “The community is friendly, and the amenities are top-notch!” Immerse yourself in a vibrant lifestyle where comfort meets convenience. Check out our reviews to see what makes our community truly special!",
  "property_created_at": "1770684483173",
  "property_scheduletour_blurb": "At Park at Mission Hills in Broken Arrow, OK, your perfect home awaits! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Schedule a tour today and see what our residents love about vibrant community living—where every detail is tailored to enhance your experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Park at Mission Hills in Broken Arrow, OK! Our inviting one and two-bedroom floor plans offer comfort and style, creating the perfect sanctuary for your lifestyle. A team member will be in touch soon to help you find your ideal home in our vibrant community!",
  "property_virtualtours_blurb": "Welcome to Park at Mission Hills in Broken Arrow, OK, where spacious one and two-bedroom apartments blend modern elegance with comfort. Unveil the charm of our community from the comfort of your home! Take a virtual tour today and imagine your new lifestyle in this inviting oasis.",
  "property_copyright": "2026 All Rights Reserved. Park at Mission Hills",
  "property_seo_title_home": "Park at Mission Hills |  Apartments in Broken Arrow, OK",
  "property_seo_description_home": "Experience comfort at Park at Mission Hills in Broken Arrow! Enjoy pet-friendly living, resort-style pools, and modern amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Broken Arrow, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Park at Mission Hills in Broken Arrow, OK! Browse unique one and two-bedroom floor plans designed for comfort and style.",
  "property_seo_title_amenities": "Amenities | Broken Arrow, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Park at Mission Hills! Enjoy pet-friendly living, relaxing ponds, resort-style pools, and modern amenities tailored for you.",
  "property_seo_title_gallery": "Gallery | Apartments in Broken Arrow, OK",
  "property_seo_description_gallery": "Imagine life at Park at Mission Hills in Broken Arrow, OK! Enjoy luxury amenities, from resort-style pools to pet-friendly spaces. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Park at Mission Hills Apartments",
  "property_seo_description_virtualtours": "Step inside Park at Mission Hills in Broken Arrow, OK! Take a virtual tour of our inviting one and two-bedroom apartments today. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Park at Mission Hills Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Park at Mission Hills, Broken Arrow! Enjoy modern amenities, pet-friendly living, and resort-style pools. Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Broken Arrow, OK",
  "property_seo_description_neighborhood": "Uncover Broken Arrow's gems near Park at Mission Hills! From cozy cafes to scenic parks, dive into local favorites and vibrant hotspots right at your doorstep.",
  "property_seo_title_contact": "Contact Us | Park at Mission Hills",
  "property_seo_description_contact": "Contact Park at Mission Hills in Broken Arrow, OK! Our team is ready to help with inquiries about our spacious one and two-bedroom apartments.",
  "property_seo_title_faqs": "FAQs | Apartments in Broken Arrow, OK",
  "property_seo_description_faqs": "Discover Park at Mission Hills! Explore pet-friendly amenities and resort-style pools in our FAQs for your perfect living experience in Broken Arrow, OK.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Broken Arrow, OK",
  "property_seo_description_reviews": "Join our vibrant community at Park at Mission Hills in Broken Arrow, OK. Hear from our residents about pet-friendly living, resort-style amenities, and more!",
  "property_seo_title_applynow": "Apply Now | Apartments in Broken Arrow, OK",
  "property_seo_description_applynow": "Experience comfort at Park at Mission Hills in Broken Arrow, OK. Enjoy resort-style amenities, pet-friendly living, and modern floor plans. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Park at Mission Hills",
  "property_seo_description_residentaccess": "Log in to Park at Mission Hills' portal for easy rent payments, maintenance requests, and community updates. Convenience awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Park at Mission Hills",
  "property_seo_description_referafriend": "Refer a friend to Park at Mission Hills in Broken Arrow, OK! Enjoy living in a vibrant community where great friends create the best neighborhood vibes.",
  "property_seo_title_scheduletour": "Schedule a Tour | Park at Mission Hills",
  "property_seo_description_scheduletour": "Experience comfort and style at Park at Mission Hills in Broken Arrow, OK. Schedule a tour today and find your perfect apartment home!",
  "property_seo_title_privacy": "Privacy Policy | Park at Mission Hills",
  "property_seo_description_privacy": "Your privacy matters at Park at Mission Hills. Dive into our Privacy Policy to see how we safeguard your information in Broken Arrow, OK. Review it today!",
  "property_seo_title_accessibility": "Website Accessibility | Park at Mission Hills",
  "property_seo_description_accessibility": "At Park at Mission Hills in Broken Arrow, OK, we're committed to digital inclusion. Explore our accessibility features and enjoy a welcoming living experience!",
  "property_seo_title_sitemap": "Sitemap | Park at Mission Hills",
  "property_seo_description_sitemap": "Navigate your way to the perfect home at Park at Mission Hills in Broken Arrow, OK! Check out our sitemap for all the details on our community and amenities.",
  "property_seo_title_thankyou": "Thank You | Park at Mission Hills",
  "property_seo_description_thankyou": "Thank you for reaching out to Park at Mission Hills! Expect a warm welcome and personalized attention from our team. We can’t wait to connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Broken Arrow, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865493291",
  "amenities": [
    {
      "id": "ec_0ee89e2bd1bada192a2d50d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396845",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53f38082d1a488de4cf595f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396846",
      "title": "Relaxing Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0aa24e223192e8b0a6df091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396847",
      "title": "Onsite Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afbd04d5e0a73815f1bd3b77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396848",
      "title": "2 Business Centers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec7b9ca3895f0148956b8fce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396850",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0e1ed753f839c85709002c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396851",
      "title": "Limited-Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a97cfa3879aa8ca5b48688fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396852",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_567d5dc11542ab836a79f986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396853",
      "title": "2 24-Hour Fitness Centers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0034ec94348f71c1899177f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396854",
      "title": "Accepts Electronic Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cb3398a0f2eb750ee37e939",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396855",
      "title": "Onsite Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e44c9f16368813499d1c2ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396856",
      "title": "Onsite Management with Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8580f45f5d09c71117a0ad72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396857",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc2415ae481a0e4c1ca608ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396858",
      "title": "2 Resort-Style Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c556f68a00daca35df923c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396859",
      "title": "Sundecks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d5b0d71c7c4c5d8dafaf970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127396860",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f3721ae4936bf13fcdc52bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "128042542",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb13b96ca180d33d4a3226a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398318",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0524ce0b9d09b80cec778f31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398319",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba4f208def753785985e7d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398320",
      "title": "Handrails",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2149bcf8799333e228f2ff4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398321",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4d9c27c1ad0faa77040b241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398322",
      "title": "Central Heat & Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28a7cd3c573f7e0d6b4f1970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398323",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7630427ee57ef6d9861a159",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398324",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73a30a322c9532f5470bf7bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398325",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac133fe3bba8563cc85db7a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398326",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2413e1d0d79388cb36d3af2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398327",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0637f552879d40c5ead83f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398328",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb85c6db06386432f597c048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398329",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9f41fbc24e9597933779e0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398330",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eeac9aadca6cb9dd4c1997a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398331",
      "title": "Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f52df0917e8f0fb5d75f1bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398332",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b107a215286688caefdfaa56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398333",
      "title": "Wheelchair Access*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_412c3c07db7205e99195114a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398334",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1668481b7ba122015f557119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398335",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_071cf65eedd650b0c36f2d85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "yardi",
      "external_id": "127398336",
      "title": "2-inch Window Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c016a88f-54b6-46cb-8b0e-8c993d7211c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db691-0472-73fa-96fb-0a2bab61fcf2.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019db691-0472-73fa-96fb-0a2bab61fcf2",
        "storage_key": "property/6767906449167043/019db691-0472-73fa-96fb-0a2bab61fcf2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b4ee1b0-a7df-4d3d-9b04-b670ea1bd93f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-fdce-77fc-94dc-634de5a95bd2.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with a stone fireplace, grill, and seating under umbrellas.",
        "public_id": "019db690-fdce-77fc-94dc-634de5a95bd2",
        "storage_key": "property/6767906449167043/019db690-fdce-77fc-94dc-634de5a95bd2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with the community fireplace, grills, and comfortable seating areas available to residents.",
      "link": "",
      "alt_text": "Outdoor patio area with a stone fireplace, grill, and seating under umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c9cc8ac-81d2-4ce4-84c2-e267a1f574ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-faa7-7255-a2cd-3d8d75ac3c92.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and fireplace area with picnic tables and umbrellas.",
        "public_id": "019db690-faa7-7255-a2cd-3d8d75ac3c92",
        "storage_key": "property/6767906449167043/019db690-faa7-7255-a2cd-3d8d75ac3c92.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor grilling station and stone fireplace, perfect for social gatherings. Features include picnic tables and ample seating.",
      "link": "",
      "alt_text": "Outdoor grilling and fireplace area with picnic tables and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_013ec1e4-c7c7-4e6b-921e-1cbb3b479b5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-fa49-777a-8ad7-610d53efc32b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
        "public_id": "019db690-fa49-777a-8ad7-610d53efc32b",
        "storage_key": "property/6767906449167043/019db690-fa49-777a-8ad7-610d53efc32b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a25ad838-e88d-4b3c-9a5c-6a7c05a1830f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-c006-754e-ad8b-9195847ba9a0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019db690-c006-754e-ad8b-9195847ba9a0",
        "storage_key": "property/6767906449167043/019db690-c006-754e-ad8b-9195847ba9a0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling resort-style pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32929599-ea2d-475e-b5b5-c8e0c3b444df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-9601-744c-bf34-1fbe30b093d0.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking a pond with fountain, green lawn, and apartment buildings in the background.",
        "public_id": "019db690-9601-744c-bf34-1fbe30b093d0",
        "storage_key": "property/6767906449167043/019db690-9601-744c-bf34-1fbe30b093d0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the scenic views from your private balcony, overlooking a tranquil pond and lush green spaces. Relax and unwind in this beautiful community setting.",
      "link": "",
      "alt_text": "View from balcony overlooking a pond with fountain, green lawn, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bed75eff-617f-4ed0-8de9-9cbddf29376e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-5e7e-73b9-9133-d6581ec3a65e.webp",
      "image_media": {
        "alt_text": "Interior of a well-equipped fitness center with cardio machines, free weights, and exercise balls.",
        "public_id": "019db690-5e7e-73b9-9133-d6581ec3a65e",
        "storage_key": "property/6767906449167043/019db690-5e7e-73b9-9133-d6581ec3a65e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio equipment, free weights, and strength training machines to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Interior of a well-equipped fitness center with cardio machines, free weights, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f52b99c-8510-4da4-93af-f63154e34db6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-5e7b-76a5-8694-8d2e60e646d2.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and stability balls.",
        "public_id": "019db690-5e7b-76a5-8694-8d2e60e646d2",
        "storage_key": "property/6767906449167043/019db690-5e7b-76a5-8694-8d2e60e646d2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Gym with weight machines, treadmills, and stability balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a189915-4954-4b19-88c6-d4c62355d5c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db690-35d1-755e-b548-881c9461fd17.webp",
      "image_media": {
        "alt_text": "Apartment buildings overlooking a lake with a fountain and ducks.",
        "public_id": "019db690-35d1-755e-b548-881c9461fd17",
        "storage_key": "property/6767906449167043/019db690-35d1-755e-b548-881c9461fd17.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience serene living at this apartment complex, featuring beautiful buildings set against a picturesque lake with a fountain and a family of ducks.",
      "link": "",
      "alt_text": "Apartment buildings overlooking a lake with a fountain and ducks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08a6aa3e-e36e-4da4-8fb5-9d91230eaa7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-f044-7359-bb94-a9409029ddcf.webp",
      "image_media": {
        "alt_text": "A bathroom vanity with a sink, marble countertops, and a large mirror.",
        "public_id": "019db68f-f044-7359-bb94-a9409029ddcf",
        "storage_key": "property/6767906449167043/019db68f-f044-7359-bb94-a9409029ddcf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a modern vanity, ample counter space, and decorative artwork.",
      "link": "",
      "alt_text": "A bathroom vanity with a sink, marble countertops, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c03de269-665a-4879-ba68-88ffc8ee2a2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-ea14-7688-a04a-098696b82e53.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, bathtub, and vanity with a sink.",
        "public_id": "019db68f-ea14-7688-a04a-098696b82e53",
        "storage_key": "property/6767906449167043/019db68f-ea14-7688-a04a-098696b82e53.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with a shower, a toilet, and a spacious vanity with a sink and ample counter space.",
      "link": "",
      "alt_text": "Bathroom with a toilet, bathtub, and vanity with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae2089ac-d897-4652-91a2-ee75e40690d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-df86-764c-9f4e-439cdb5a81b3.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, dresser, and ceiling fan.",
        "public_id": "019db68f-df86-764c-9f4e-439cdb5a81b3",
        "storage_key": "property/6767906449167043/019db68f-df86-764c-9f4e-439cdb5a81b3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Serene primary bedroom featuring a queen-size bed with plush bedding, a spacious dresser with a mirror, and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Primary bedroom with a queen-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b372d2f0-a341-486b-80fb-e80329e87a7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-df9f-75ac-9b31-5d7943dbe6a0.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table, four chairs, and a plant.",
        "public_id": "019db68f-df9f-75ac-9b31-5d7943dbe6a0",
        "storage_key": "property/6767906449167043/019db68f-df9f-75ac-9b31-5d7943dbe6a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Charming dining area featuring a round wooden table with four chairs, perfect for intimate meals. Includes a decorative plant and artwork.",
      "link": "",
      "alt_text": "Dining area with a round wooden table, four chairs, and a plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65c4d83f-aca7-4790-b5c3-2ec800df30c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-d214-739f-b19c-7edb015cd973.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, couch, and armchair.",
        "public_id": "019db68f-d214-739f-b19c-7edb015cd973",
        "storage_key": "property/6767906449167043/019db68f-d214-739f-b19c-7edb015cd973.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and decorative elements, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a fireplace, couch, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3bc86de-556e-4da9-afc1-7908ae8a5372",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-d111-7351-afe7-ced3f7ce3f7d.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, television, and sofa.",
        "public_id": "019db68f-d111-7351-afe7-ced3f7ce3f7d",
        "storage_key": "property/6767906449167043/019db68f-d111-7351-afe7-ced3f7ce3f7d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center, and comfortable seating, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a fireplace, television, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a87ae363-7e62-46b8-86c1-3be1aa9fe479",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-bef7-7708-97f2-33c3717a51e7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with sofa, dining table, bar stools, and kitchen counter.",
        "public_id": "019db68f-bef7-7708-97f2-33c3717a51e7",
        "storage_key": "property/6767906449167043/019db68f-bef7-7708-97f2-33c3717a51e7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area seamlessly connected to a modern kitchen with a breakfast bar. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Living room and kitchen area with sofa, dining table, bar stools, and kitchen counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_735a1a13-b8e1-4dfa-b48e-a3a3f34d3448",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-bcbe-756a-9c3f-91a1ff70a438.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace, large sofa, and dining area.",
        "public_id": "019db68f-bcbe-756a-9c3f-91a1ff70a438",
        "storage_key": "property/6767906449167043/019db68f-bcbe-756a-9c3f-91a1ff70a438.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a warm fireplace, comfortable seating, and a stylish dining space perfect for entertaining.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace, large sofa, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54bd35cb-dc1d-4170-9d44-73f58b7086e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-be30-707e-86da-6f1a38d0c243.webp",
      "image_media": {
        "alt_text": "Business center with computers and a printer.",
        "public_id": "019db68f-be30-707e-86da-6f1a38d0c243",
        "storage_key": "property/6767906449167043/019db68f-be30-707e-86da-6f1a38d0c243.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our business center, equipped with computers and a printer for your convenience.",
      "link": "",
      "alt_text": "Business center with computers and a printer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c89d43c-12c8-41f9-a054-477ae2a59d8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-b53c-732e-bdc0-29736911b8ee.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with a large stone fireplace, comfortable seating, and a dining table.",
        "public_id": "019db68f-b53c-732e-bdc0-29736911b8ee",
        "storage_key": "property/6767906449167043/019db68f-b53c-732e-bdc0-29736911b8ee.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Gather in our beautifully appointed community lounge, featuring a cozy fireplace, ample seating, and a communal dining area perfect for socializing.",
      "link": "",
      "alt_text": "Spacious community lounge area with a large stone fireplace, comfortable seating, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28e04e20-406f-4bde-92e3-3880a4b45ad7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-c450-72d6-a71d-c583f3b3a869.webp",
      "image_media": {
        "alt_text": "View of a kitchen island with a sink and dishwasher, overlooking a living area with a fireplace and seating.",
        "public_id": "019db68f-c450-72d6-a71d-c583f3b3a869",
        "storage_key": "property/6767906449167043/019db68f-c450-72d6-a71d-c583f3b3a869.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious open-concept living area featuring a cozy fireplace and a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "View of a kitchen island with a sink and dishwasher, overlooking a living area with a fireplace and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0442d16-37a3-4fe2-b4b3-4d45a28eb631",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-c3e2-775b-a799-399971fdbcc1.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019db68f-c3e2-775b-a799-399971fdbcc1",
        "storage_key": "property/6767906449167043/019db68f-c3e2-775b-a799-399971fdbcc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, stainless steel appliances including a microwave, oven, and dishwasher, and elegant granite countertops.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe3f6df4-1632-44a5-9dda-569bee14d487",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-9450-7408-93c8-f0ad47c7d5ab.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a seesaw under a blue sky with clouds.",
        "public_id": "019db68f-9450-7408-93c8-f0ad47c7d5ab",
        "storage_key": "property/6767906449167043/019db68f-9450-7408-93c8-f0ad47c7d5ab.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring agility equipment and a seesaw for your furry friends to play and exercise in a safe, fenced-in environment.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a seesaw under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_677df547-0760-4fe1-ac4e-ac0406a44ac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-a94e-71e3-bece-d698379612ed.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with elegant seating and modern decor, featuring a vaulted ceiling and large windows.",
        "public_id": "019db68f-a94e-71e3-bece-d698379612ed",
        "storage_key": "property/6767906449167043/019db68f-a94e-71e3-bece-d698379612ed.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, perfect for socializing or quiet contemplation. Enjoy the sophisticated ambiance and comfortable seating.",
      "link": "",
      "alt_text": "Spacious lounge area with elegant seating and modern decor, featuring a vaulted ceiling and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac6471bc-b735-4447-8eb0-648758d40a72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-860b-75cf-934b-5d6e2c66f593.webp",
      "image_media": {
        "alt_text": "The Park at Mission Hills luxury apartments monument sign with brick pillars and landscaping.",
        "public_id": "019db68f-860b-75cf-934b-5d6e2c66f593",
        "storage_key": "property/6767906449167043/019db68f-860b-75cf-934b-5d6e2c66f593.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Park at Mission Hills, where luxury living meets convenience. Our beautiful community offers a serene escape with its well-maintained landscaping and elegant monument sign.",
      "link": "",
      "alt_text": "The Park at Mission Hills luxury apartments monument sign with brick pillars and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d30b6136-48a8-4e93-90e6-39e65dd8f2bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-85e8-7434-8c25-2f99df3bc135.webp",
      "image_media": {
        "alt_text": "Exterior view of the Mission Hills apartment complex entrance and tower.",
        "public_id": "019db68f-85e8-7434-8c25-2f99df3bc135",
        "storage_key": "property/6767906449167043/019db68f-85e8-7434-8c25-2f99df3bc135.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to Mission Hills, featuring a beautiful stone facade entrance and an elegant tower. Explore our community amenities and find your new home.",
      "link": "",
      "alt_text": "Exterior view of the Mission Hills apartment complex entrance and tower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb8dff60-e5cb-4c45-8ba2-1e22dcd01e87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-8550-732a-914d-21503f9047e7.webp",
      "image_media": {
        "alt_text": "Apartments at Mission Mills exterior view with cars and landscaping",
        "public_id": "019db68f-8550-732a-914d-21503f9047e7",
        "storage_key": "property/6767906449167043/019db68f-8550-732a-914d-21503f9047e7.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "View of the Apartments at Mission Mills exterior with parking lot and entrance.",
      "link": "",
      "alt_text": "Apartments at Mission Mills exterior view with cars and landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17130f65-5c9b-482d-a5cb-9d76f4cd10b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-89ab-71ef-bf88-c9dc0a79888c.webp",
      "image_media": {
        "alt_text": "Dog park playground with tunnels, ramps, and agility equipment.",
        "public_id": "019db68f-89ab-71ef-bf88-c9dc0a79888c",
        "storage_key": "property/6767906449167043/019db68f-89ab-71ef-bf88-c9dc0a79888c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring fun agility equipment for your furry friends to play on.",
      "link": "",
      "alt_text": "Dog park playground with tunnels, ramps, and agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_706626e7-6cb6-4901-871a-71ebc94013ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-67b2-7069-bb2e-26cc732dd27a.webp",
      "image_media": {
        "alt_text": "Welcome to Canine Pass, a pet-friendly park with agility equipment and seating.",
        "public_id": "019db68f-67b2-7069-bb2e-26cc732dd27a",
        "storage_key": "property/6767906449167043/019db68f-67b2-7069-bb2e-26cc732dd27a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our dedicated pet-friendly park, 'Canine Pass,' featuring agility equipment for your furry friends and comfortable seating for you.",
      "link": "",
      "alt_text": "Welcome to Canine Pass, a pet-friendly park with agility equipment and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa73cc95-c7ca-48ee-82f8-64702fca63cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-5e04-734d-9b4b-4124450c0f46.webp",
      "image_media": {
        "alt_text": "Living room with a white sectional sofa, a TV on a stand, and a kitchen area with bar stools.",
        "public_id": "019db68f-5e04-734d-9b4b-4124450c0f46",
        "storage_key": "property/6767906449167043/019db68f-5e04-734d-9b4b-4124450c0f46.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting living space, featuring a spacious sectional sofa, entertainment center, and a breakfast bar connecting to the kitchen.",
      "link": "",
      "alt_text": "Living room with a white sectional sofa, a TV on a stand, and a kitchen area with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef28c393-8cb5-447f-92e6-c5cedd146431",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-6366-706e-959d-e02a7630b682.webp",
      "image_media": {
        "alt_text": "Balcony view of a lake with fountains and apartment buildings in the background.",
        "public_id": "019db68f-6366-706e-959d-e02a7630b682",
        "storage_key": "property/6767906449167043/019db68f-6366-706e-959d-e02a7630b682.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, overlooking a serene lake and lush landscaping.",
      "link": "",
      "alt_text": "Balcony view of a lake with fountains and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_94085f28-df0d-4c36-850b-a5d0661072b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves tasty steaks, ribs, and fried pickles, and the rolls are delicious. They also highlight the affordable prices, lively atmosphere, and attentive service.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-0d28-71fb-8a4d-9b65f1195a1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0d28-71fb-8a4d-9b65f1195a1d",
        "storage_key": "property/6767906449167043/019d270e-0d28-71fb-8a4d-9b65f1195a1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-437a-75ba-8fc0-d0c43b5c2e88",
        "storage_key": "property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_e1a3af89-1cb2-42a7-8c90-ec3210469994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-0ce3-755e-ab20-29c487fd2aa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0ce3-755e-ab20-29c487fd2aa0",
        "storage_key": "property/6767906449167043/019d270e-0ce3-755e-ab20-29c487fd2aa0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-437a-75ba-8fc0-d0c43b5c2e88",
        "storage_key": "property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b2106ec4-0d5f-4955-800c-9e985cac1f6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "People say this restaurant serves delicious croissants, steak, and salmon. They also highlight the reasonable prices, generous portions, and friendly service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-0d48-76fa-925a-a756788b1ff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0d48-76fa-925a-a756788b1ff2",
        "storage_key": "property/6767906449167043/019d270e-0d48-76fa-925a-a756788b1ff2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-437a-75ba-8fc0-d0c43b5c2e88",
        "storage_key": "property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1f7d4535-fbe7-4f54-99fb-573bb84ce67d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Tulsa’s Incredible Food and Fun",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Popular place for parties offering go-karts, rides, games & pizza with an all-you-can-eat buffet.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food choices, including pizza, hot dogs, tacos, desserts, and a salad bar, and has fun games and attractions like laser tag, bumper cars, and go-karts. They also highlight the great deals, fun atmosphere, and helpful staff.\n\nOther reviews mention the food can be mediocre.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-0c68-73fd-a80a-3a25e7dbce03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0c68-73fd-a80a-3a25e7dbce03",
        "storage_key": "property/6767906449167043/019d270e-0c68-73fd-a80a-3a25e7dbce03.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblefoodandfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsas-incredible-food-and-fun",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-437a-75ba-8fc0-d0c43b5c2e88",
        "storage_key": "property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_2ca57656-dd48-4b70-afd5-d08daec78c5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Restaurants",
      "poi_address": "16141 E Skelly Dr, Tulsa, OK 74116, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1121-760e-84e8-044b50d01837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1121-760e-84e8-044b50d01837",
        "storage_key": "property/6767906449167043/019d270e-1121-760e-84e8-044b50d01837.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ok/tulsa/16141-e-skelly-dr?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM4NzctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3637781810313467114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "36.1640654",
      "poi_longitude": "-95.7953876",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-234-0380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-437a-75ba-8fc0-d0c43b5c2e88",
        "storage_key": "property/6767906449167043/019d270e-437a-75ba-8fc0-d0c43b5c2e88.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcluVYv0tocR6pQcXkj_ezI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_879ee4ca-0d55-479e-ab5e-8b4712e355fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "2-story enclosed mall with many chain stores & boutiques, plus a kids’ play area & a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including a new Scheels with an indoor Ferris wheel, and a good-sized food court. They also highlight the clean, safe, and friendly atmosphere, and the fun activities like a carousel and arcade.\n\nSome reviews mention the escalators can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1343-70fa-8ffa-a1267b736d04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1343-70fa-8ffa-a1267b736d04",
        "storage_key": "property/6767906449167043/019d270e-1343-70fa-8ffa-a1267b736d04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4340-7570-b6ba-cb9f2adb8175.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4340-7570-b6ba-cb9f2adb8175",
        "storage_key": "property/6767906449167043/019d270e-4340-7570-b6ba-cb9f2adb8175.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_32e03383-0254-4e35-abd0-7193da76fcf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Shoppers say this grocery store offers great prices on a wide variety of items, including bulk goods like candy, nuts, and grains, and fresh produce, meat, and seafood. They also highlight the 24-hour availability and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1250-76df-ae03-77456041f089.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1250-76df-ae03-77456041f089",
        "storage_key": "property/6767906449167043/019d270e-1250-76df-ae03-77456041f089.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-434e-71f3-9b85-6f1f34637fd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-434e-71f3-9b85-6f1f34637fd9",
        "storage_key": "property/6767906449167043/019d270e-434e-71f3-9b85-6f1f34637fd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b31da23f-1c06-4fd9-8caf-4b50613744f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1246-7468-ad51-a6bf1c3d6b1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1246-7468-ad51-a6bf1c3d6b1a",
        "storage_key": "property/6767906449167043/019d270e-1246-7468-ad51-a6bf1c3d6b1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-434e-71f3-9b85-6f1f34637fd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-434e-71f3-9b85-6f1f34637fd9",
        "storage_key": "property/6767906449167043/019d270e-434e-71f3-9b85-6f1f34637fd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_2e7f4b03-bc5a-402f-9383-1e362bfcf98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a good selection of products and courteous staff. They also highlight the rewards program, which can be helpful for saving money on future purchases.\n\nSome reviews mention the self-checkout can be frustrating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-152d-7041-a40e-952109a26afb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-152d-7041-a40e-952109a26afb",
        "storage_key": "property/6767906449167043/019d270e-152d-7041-a40e-952109a26afb.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Broken-Arrow/1536?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1536-_-na-_-0-_-0&y_source=1_MTE4NDM5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12318214238171197715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.0623",
      "poi_longitude": "-95.7672",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-4926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4340-7570-b6ba-cb9f2adb8175.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4340-7570-b6ba-cb9f2adb8175",
        "storage_key": "property/6767906449167043/019d270e-4340-7570-b6ba-cb9f2adb8175.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg5dy-UuKtocRE3FavZUW86o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a2c3d23d-d532-4bcd-863d-682dbb8ba86c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-171c-72ae-815a-7ea234f6b2d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-171c-72ae-815a-7ea234f6b2d2",
        "storage_key": "property/6767906449167043/019d270e-171c-72ae-815a-7ea234f6b2d2.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0598878",
      "poi_longitude": "-95.8665158",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4340-7570-b6ba-cb9f2adb8175.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4340-7570-b6ba-cb9f2adb8175",
        "storage_key": "property/6767906449167043/019d270e-4340-7570-b6ba-cb9f2adb8175.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_641614dc-5314-4649-acb5-fa8626b28045",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-174d-712e-8218-3cc7586aad7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-174d-712e-8218-3cc7586aad7f",
        "storage_key": "property/6767906449167043/019d270e-174d-712e-8218-3cc7586aad7f.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-436a-7234-bd0f-7df157dff68b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-436a-7234-bd0f-7df157dff68b",
        "storage_key": "property/6767906449167043/019d270e-436a-7234-bd0f-7df157dff68b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_403b9aa0-e96b-4a53-b8b3-4cc969edd511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1aac-76e8-904c-c8639a11bf5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1aac-76e8-904c-c8639a11bf5a",
        "storage_key": "property/6767906449167043/019d270e-1aac-76e8-904c-c8639a11bf5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019379",
      "poi_longitude": "-95.748523",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-436a-7234-bd0f-7df157dff68b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-436a-7234-bd0f-7df157dff68b",
        "storage_key": "property/6767906449167043/019d270e-436a-7234-bd0f-7df157dff68b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2be28e14-99a2-40d4-a74c-6599e79a0f12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Martin Regional Library",
      "poi_type": "Education",
      "poi_address": "2601 S Garnett Rd, Tulsa, OK 74129, USA",
      "poi_short_description": "Public library with a range of services, including faxing, computers, and meetings, plus Vietnamese books.",
      "poi_long_description": "People say this public library offers a wide variety of books, free activities for children, and access to computers and printers. They highlight the quiet and comfortable atmosphere, and the helpful and friendly staff. They also like the convenient location and long operating hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1a06-757c-930d-b9196415f892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1a06-757c-930d-b9196415f892",
        "storage_key": "property/6767906449167043/019d270e-1a06-757c-930d-b9196415f892.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/martin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046822168243383481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-regional-library",
      "poi_latitude": "36.1265968",
      "poi_longitude": "-95.8505489",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-436a-7234-bd0f-7df157dff68b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-436a-7234-bd0f-7df157dff68b",
        "storage_key": "property/6767906449167043/019d270e-436a-7234-bd0f-7df157dff68b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF1eFsi7ztocRuawafrmg6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3efb5e2a-7206-4181-87b5-12798754db13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "TCC Southeast Library",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St Building 7, Room 7200, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1ca1-70ec-a465-22c28af5dc6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1ca1-70ec-a465-22c28af5dc6d",
        "storage_key": "property/6767906449167043/019d270e-1ca1-70ec-a465-22c28af5dc6d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://library.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341227726380407188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tcc-southeast-library",
      "poi_latitude": "36.0433144",
      "poi_longitude": "-95.8632335",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-595-7701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-474e-77d6-bdd4-ea8f5d028216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-474e-77d6-bdd4-ea8f5d028216",
        "storage_key": "property/6767906449167043/019d270e-474e-77d6-bdd4-ea8f5d028216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdNrW1mNtocRlBlTtNNrg48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_25ad7608-a8a7-4285-8ab7-675056b132e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park offers a variety of trampolines, games, and attractions suitable for kids and adults. They also highlight the fun, active, and energetic atmosphere, and the helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1c9c-7200-bef2-f3dfa243abe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1c9c-7200-bef2-f3dfa243abe2",
        "storage_key": "property/6767906449167043/019d270e-1c9c-7200-bef2-f3dfa243abe2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c9a30b6a-6942-42e4-8fd9-c66899c6fd1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Tiger Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-1f06-7387-93eb-1ba406f351cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1f06-7387-93eb-1ba406f351cd",
        "storage_key": "property/6767906449167043/019d270e-1f06-7387-93eb-1ba406f351cd.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "https://batigersports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374532252761582339&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiger-memorial-stadium",
      "poi_latitude": "36.0743308",
      "poi_longitude": "-95.7632923",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-259-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-477c-76b2-8c08-9e7cc407b244.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-477c-76b2-8c08-9e7cc407b244",
        "storage_key": "property/6767906449167043/019d270e-477c-76b2-8c08-9e7cc407b244.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SOplVCKtocRA-sfZ0_jdlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_edc6b77e-8872-495c-a99a-6e0e41f4edfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "The Museum Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "400 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_long_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2030-710f-8406-a1c57daa2129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2030-710f-8406-a1c57daa2129",
        "storage_key": "property/6767906449167043/019d270e-2030-710f-8406-a1c57daa2129.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brokenarrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351764218256934691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-broken-arrow",
      "poi_latitude": "36.0491954",
      "poi_longitude": "-95.7911106",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-258-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4785-7631-a145-a525634ad0d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4785-7631-a145-a525634ad0d5",
        "storage_key": "property/6767906449167043/019d270e-4785-7631-a145-a525634ad0d5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxSi48KLtocRI8cl0Osi7eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3e7c6dc7-ddcc-4991-b42b-4f670fcded97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Rose District Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "416 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Popular destination featuring a fountain and splash pad where kids can play in the water and adults can relax.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-219a-747c-9cf9-ba128d321179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-219a-747c-9cf9-ba128d321179",
        "storage_key": "property/6767906449167043/019d270e-219a-747c-9cf9-ba128d321179.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://rosedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7184917167890550428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-district-splash-pad",
      "poi_latitude": "36.0488437",
      "poi_longitude": "-95.7910116",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0CU3cKLtocRnM64zBj0tWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_07dd985b-2616-4ab2-b5c2-12166ab3b437",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Military History Museum",
      "poi_type": "Entertainment",
      "poi_address": "112 N Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Tours and exhibits of military history that feature donated artifacts and memorabilia.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2225-726c-bdbd-87056393963d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2225-726c-bdbd-87056393963d",
        "storage_key": "property/6767906449167043/019d270e-2225-726c-bdbd-87056393963d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.okmhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13208418279094056410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "military-history-museum",
      "poi_latitude": "36.0528999",
      "poi_longitude": "-95.7910559",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-794-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4785-7631-a145-a525634ad0d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4785-7631-a145-a525634ad0d5",
        "storage_key": "property/6767906449167043/019d270e-4785-7631-a145-a525634ad0d5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetKKsKLtocR2nUtknG6Tbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cd1c470e-7676-4eee-b29b-5954a3d149d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, a clean facility, and a friendly and helpful staff. They also highlight the spacious layout, the positive and motivating atmosphere, and the great value for the price.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-24c8-77e8-bf5b-9a74aaa29bf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-24c8-77e8-bf5b-9a74aaa29bf3",
        "storage_key": "property/6767906449167043/019d270e-24c8-77e8-bf5b-9a74aaa29bf3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_24fa7452-934a-4202-9f8b-1f2ff49508c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 N Elm St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, including tanning beds, in a clean environment.",
      "poi_long_description": "People say this gym offers a wide variety of weight machines, free weights, and cardio equipment, including several Smith machines. They highlight the affordable memberships, convenient location, and clean, well-maintained facility. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-25cf-7293-b46d-1739c1ddc477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-25cf-7293-b46d-1739c1ddc477",
        "storage_key": "property/6767906449167043/019d270e-25cf-7293-b46d-1739c1ddc477.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/broken-arrow-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8211862053813118143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0700775",
      "poi_longitude": "-95.7999697",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-739-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfEd95mLtocRv2QKlgdl9nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a2d9e2fe-db49-4d00-b9b8-38cf7b29533c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7990 E 51st St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of fitness and yoga classes, including RED HIIT and Studio Flow Yoga, and has a spacious, clean, and motivating atmosphere. They also highlight the knowledgeable and supportive instructors, the friendly and helpful staff, and the sense of community.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2733-752c-96e9-8cda4983e015.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2733-752c-96e9-8cda4983e015",
        "storage_key": "property/6767906449167043/019d270e-2733-752c-96e9-8cda4983e015.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/tulsa/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684131092404226149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "36.0885483",
      "poi_longitude": "-95.8878289",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-984-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXRVgW-NtocRZcjZx1JfJqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4e1f7cd1-b883-44a1-8f71-6577eefb674f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-28a3-747a-a846-cd2e9f7a8f5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-28a3-747a-a846-cd2e9f7a8f5a",
        "storage_key": "property/6767906449167043/019d270e-28a3-747a-a846-cd2e9f7a8f5a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b9e31a8c-52bc-44bf-b2f8-328609f561d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Umac Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Gym featuring basketball and volleyball courts, plus facilities for wrestling, cheerleading, and other competitions.",
      "poi_long_description": "People say this gym is a beautiful facility with plenty of parking. They highlight the positive learning environment and the impressive, clean space. They also like the large size, suitable for events like cheer championships and technology symposiums.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2957-74f8-bcdb-6c41b824eb58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2957-74f8-bcdb-6c41b824eb58",
        "storage_key": "property/6767906449167043/019d270e-2957-74f8-bcdb-6c41b824eb58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unionps.org/activities/umac",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233318345147314712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umac-tulsa",
      "poi_latitude": "36.0641918",
      "poi_longitude": "-95.8694283",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo05n3rqNtocRGHK6l7oLKe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4f7a7b6d-0555-4fb0-99c9-89bc58018d31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "R.C. Dickenson Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Classes, pool and gym with friendly staff plus a variety of exercise machines.",
      "poi_long_description": "People say this gym offers a variety of equipment and is great for workouts. They highlight the youth flag football program and the pool. They also like the family-friendly vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2a75-71df-a80f-b71ea1647361.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2a75-71df-a80f-b71ea1647361",
        "storage_key": "property/6767906449167043/019d270e-2a75-71df-a80f-b71ea1647361.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcatulsa.org/dickenson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3422791293805268507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rc-dickenson-family-ymca",
      "poi_latitude": "36.0410595",
      "poi_longitude": "-95.8496234",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-872-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0w56y6MtocRGw6QB4wygC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6b8a7d5a-a43c-494d-bf79-0ca2c028284b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Animal Emergency Center of Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "4055 S 102nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2bae-7659-9d2b-c1ac1b9b29ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2bae-7659-9d2b-c1ac1b9b29ea",
        "storage_key": "property/6767906449167043/019d270e-2bae-7659-9d2b-c1ac1b9b29ea.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://aectulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5673475209959077837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency-center-of-tulsa",
      "poi_latitude": "36.1054336",
      "poi_longitude": "-95.8632907",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-665-0508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xcYAlmNtocRzXeY46Q7vE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3a772dea-5191-438e-b583-0c5fe21c7afc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Miami Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "2409 W Kenosha St #161, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2d0b-730a-ad1d-2339d439e75e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2d0b-730a-ad1d-2339d439e75e",
        "storage_key": "property/6767906449167043/019d270e-2d0b-730a-ad1d-2339d439e75e.webp",
        "width": 900,
        "height": 900
      },
      "poi_business_url": "https://miaminailsbrokenarrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18392555638477026749&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "miami-nails",
      "poi_latitude": "36.0596694",
      "poi_longitude": "-95.8197326",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-251-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYxGgXSMtocRvfUHv-d7P_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_3c6981bc-5820-45ca-8cf2-73f7e2135274",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Tulsa Animal Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "6119 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2ecf-778f-89ad-7136264e9b01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2ecf-778f-89ad-7136264e9b01",
        "storage_key": "property/6767906449167043/019d270e-2ecf-778f-89ad-7136264e9b01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tulsaurgentvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6226739192106267588&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-animal-urgent-care",
      "poi_latitude": "36.074692",
      "poi_longitude": "-95.8676795",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-417-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZA5V6SNtocRxDN_9k3SaVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_71e0613a-c62a-46bd-8270-cb167b18779f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Saint Francis Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "10501 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-2f43-765d-aea8-478682fca14a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2f43-765d-aea8-478682fca14a",
        "storage_key": "property/6767906449167043/019d270e-2f43-765d-aea8-478682fca14a.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406794313894727694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital-south",
      "poi_latitude": "36.0333434",
      "poi_longitude": "-95.8576667",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-307-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4ae4-722d-8c01-4ca8d50ab5b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4ae4-722d-8c01-4ca8d50ab5b8",
        "storage_key": "property/6767906449167043/019d270e-4ae4-722d-8c01-4ca8d50ab5b8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXaxi3-OtocRDhBgtecRcv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e716571b-6e3f-4392-a91a-d9fbda68ca98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Council Oak Comprehensive Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "10109 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-300f-70f7-86a0-cc819fc5e97f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-300f-70f7-86a0-cc819fc5e97f",
        "storage_key": "property/6767906449167043/019d270e-300f-70f7-86a0-cc819fc5e97f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.creekhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3324838369463455816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "council-oak-comprehensive-healthcare",
      "poi_latitude": "36.0515562",
      "poi_longitude": "-95.863328",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-233-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4ae4-722d-8c01-4ca8d50ab5b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4ae4-722d-8c01-4ca8d50ab5b8",
        "storage_key": "property/6767906449167043/019d270e-4ae4-722d-8c01-4ca8d50ab5b8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3-HdVONtocRSFB1m-EyJC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_44c65e38-24f5-4efd-a4ac-2b5f2cdd1cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1205 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful Christmas light display with thousands of lights, synchronized music, and a train ride. They highlight the festive, joyful, and magical atmosphere, and the opportunity to enjoy hot chocolate and mini donuts. They also like the free admission and easy parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-332f-77bd-8d7f-2838eb37422b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-332f-77bd-8d7f-2838eb37422b",
        "storage_key": "property/6767906449167043/019d270e-332f-77bd-8d7f-2838eb37422b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4b9f-75c0-b2aa-d3f1f8116abc",
        "storage_key": "property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4caadb29-41bd-4ac9-9a31-5d5d3a99b746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including swings, slides, and climbing structures, as well as picnic tables and benches. They highlight the park's clean, well-maintained facilities, the ample shade provided by canopy coverings, and the fenced-in area for added safety. They also like the turf grass in play areas, which helps prevent mud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-342d-71dc-9d67-b32ce71c70a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-342d-71dc-9d67-b32ce71c70a4",
        "storage_key": "property/6767906449167043/019d270e-342d-71dc-9d67-b32ce71c70a4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4b9f-75c0-b2aa-d3f1f8116abc",
        "storage_key": "property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_310576da-01e6-43e7-916d-7a32e8afadaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Battle Creek Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 N Battle Creek Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Public golf course offering multiple water challenges.",
      "poi_long_description": "People say this golf course offers challenging play and well-maintained greens. They highlight the reasonable rates and friendly staff. They also like the beautiful course and facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-3441-73f8-8d77-48a21b7d60fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3441-73f8-8d77-48a21b7d60fe",
        "storage_key": "property/6767906449167043/019d270e-3441-73f8-8d77-48a21b7d60fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.battlecreekgolf.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11341802120555861489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "battle-creek-golf-club",
      "poi_latitude": "36.0849383",
      "poi_longitude": "-95.8033736",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4bc7-720f-bc1f-b52eb0f82c99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4bc7-720f-bc1f-b52eb0f82c99",
        "storage_key": "property/6767906449167043/019d270e-4bc7-720f-bc1f-b52eb0f82c99.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2pBrXCLtocR8RWB7O8sZp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_76b55c06-ced9-402d-ba44-60db0424d6c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Jackson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 West Washington St S, Broken Arrow, OK 74012, USA",
      "poi_short_description": "A 14-acre open green space with a splash pad, fishing pond, playground & mile-long footpath.",
      "poi_long_description": "Visitors say this park offers a splash pad, playground, picnic areas, walking trails, and a pond for fishing. They also highlight that the park is clean and well-maintained, with plenty of benches and a gazebo for parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-3500-71cd-9314-1394a0efca23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3500-71cd-9314-1394a0efca23",
        "storage_key": "property/6767906449167043/019d270e-3500-71cd-9314-1394a0efca23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4376196672243292782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jackson-park",
      "poi_latitude": "36.0328632",
      "poi_longitude": "-95.8488142",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4b9f-75c0-b2aa-d3f1f8116abc",
        "storage_key": "property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3JU84KOtocRbtpO9K9fuzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_38076839-e153-4504-a251-deb2e6f7b146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "McCullough Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11534 E 25th St, Tulsa, OK 74129, USA",
      "poi_short_description": "Laid-back park featuring a pump track, a skateboard area, swing sets and a splash pad.",
      "poi_long_description": "People say this park offers a fun playground, a water pad, and a variety of recreational areas, including a pump track, basketball court, and soccer goals. They also highlight the numerous picnic tables, the enclosed bathrooms, and the convenient location near a library and church.\n\nOther reviews mention the park can be littered.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-37f9-7225-a0ac-da880a36f092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-37f9-7225-a0ac-da880a36f092",
        "storage_key": "property/6767906449167043/019d270e-37f9-7225-a0ac-da880a36f092.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cityoftulsa.org/government/departments/park-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5099528565797544021&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mccullough-park",
      "poi_latitude": "36.1280349",
      "poi_longitude": "-95.8482393",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4b9f-75c0-b2aa-d3f1f8116abc",
        "storage_key": "property/6767906449167043/019d270e-4b9f-75c0-b2aa-d3f1f8116abc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7x3nRtTztocRVeBRTjYqxUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_872c068f-d873-4896-abb3-5277d45a573c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-3985-715b-856a-296d67ab5c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3985-715b-856a-296d67ab5c6d",
        "storage_key": "property/6767906449167043/019d270e-3985-715b-856a-296d67ab5c6d.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4c18-73c5-843b-1156c4ea8f73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4c18-73c5-843b-1156c4ea8f73",
        "storage_key": "property/6767906449167043/019d270e-4c18-73c5-843b-1156c4ea8f73.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_136c758a-e1d4-4a58-914b-e013760e823f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-39c1-718c-b359-fa15193e7128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-39c1-718c-b359-fa15193e7128",
        "storage_key": "property/6767906449167043/019d270e-39c1-718c-b359-fa15193e7128.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0ff95134-b822-479e-8cc6-abd098882392",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-3aad-744b-8cc0-3f8a79fd9245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3aad-744b-8cc0-3f8a79fd9245",
        "storage_key": "property/6767906449167043/019d270e-3aad-744b-8cc0-3f8a79fd9245.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8c6ba860-2f66-4700-99fe-51283d9e3b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-3cf1-727e-87be-dbfb3510c800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3cf1-727e-87be-dbfb3510c800",
        "storage_key": "property/6767906449167043/019d270e-3cf1-727e-87be-dbfb3510c800.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ed4255dd-2f26-414d-95b0-f2cb4f303a98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "AT&T",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15901 E Skelly Dr, Tulsa, OK 74116, USA",
      "poi_short_description": "Telecommunications company providing cell phones, data plans, tablets & more.",
      "poi_long_description": "Telecommunications company providing cell phones, data plans, tablets & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-3ea8-71a9-ae48-460e15cda874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3ea8-71a9-ae48-460e15cda874",
        "storage_key": "property/6767906449167043/019d270e-3ea8-71a9-ae48-460e15cda874.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.att.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16231167116465079638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "att",
      "poi_latitude": "36.1642307",
      "poi_longitude": "-95.8000031",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-331-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB074bYn0tocRVgXn-n6wQOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_54799f91-d7a0-46f5-a1b6-894bbcb07718",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Corporate Woods BUSINESS COMPLEX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 S 129th E Ave, Tulsa, OK 74134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9788116077842907967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corporate-woods-business-complex",
      "poi_latitude": "36.09808270000001",
      "poi_longitude": "-95.8398889",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4727-75e1-b780-e06ca1c9d226",
        "storage_key": "property/6767906449167043/019d270e-4727-75e1-b780-e06ca1c9d226.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwPveuqMtocRP8MdkLZf1oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_151ee355-664b-4f4f-a827-43d22ce5b140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Centennial Middle School.",
      "poi_type": "Education",
      "poi_address": "225 E Omaha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baschools.org/o/cms",
      "poi_directions_map_url": "https://maps.google.com/?cid=288409670534732249&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "centennial-middle-school",
      "poi_latitude": "36.0876273",
      "poi_longitude": "-95.7918636",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-259-4340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b545-704e-b0a5-3abdb0ea1e89",
        "storage_key": "property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7kBlwSLtocR2ZkCOhGjAAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6f757760-2109-40fa-828c-2c264098c166",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Broken Arrow High School",
      "poi_type": "Education",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-28d8-73e8-844d-375abfc54043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-28d8-73e8-844d-375abfc54043",
        "storage_key": "property/6767906449167043/019d7917-28d8-73e8-844d-375abfc54043.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baschools.org/o/bahs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9874418802231035849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-high-school",
      "poi_latitude": "36.0739737",
      "poi_longitude": "-95.766474",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-259-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b545-704e-b0a5-3abdb0ea1e89",
        "storage_key": "property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOVb0n1GKtocRyUdrbpX7CIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_fc9bd0b9-30f7-44b7-a8f2-a0d77580e99a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-28f7-777b-9c6d-c6e8e5639d89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-28f7-777b-9c6d-c6e8e5639d89",
        "storage_key": "property/6767906449167043/019d7917-28f7-777b-9c6d-c6e8e5639d89.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.050518",
      "poi_longitude": "-95.9530171",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b545-704e-b0a5-3abdb0ea1e89",
        "storage_key": "property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a4b6cd92-f18b-455a-8ecb-69203a2a23e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Schusterman Library at OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-2b72-775a-a059-1423d3b5f420.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2b72-775a-a059-1423d3b5f420",
        "storage_key": "property/6767906449167043/019d7917-2b72-775a-a059-1423d3b5f420.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://library.tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3721120993794018421&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "schusterman-library-at-ou-tulsa",
      "poi_latitude": "36.1014089",
      "poi_longitude": "-95.9229338",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-660-3220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b546-7671-a65d-5484eecf4708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b546-7671-a65d-5484eecf4708",
        "storage_key": "property/6767906449167043/019cfb52-b546-7671-a65d-5484eecf4708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUdi2saStocRdUxXGdQTpDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d8c595c6-64cc-4365-ba20-b7f19c6ffc50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Country Lane Intermediate",
      "poi_type": "Education",
      "poi_address": "251 E Omaha St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baschools.org/o/clis",
      "poi_directions_map_url": "https://maps.google.com/?cid=2666395208267161841&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "country-lane-intermediate",
      "poi_latitude": "36.0874137",
      "poi_longitude": "-95.7899856",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-449-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b545-704e-b0a5-3abdb0ea1e89",
        "storage_key": "property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPSIhM_KKtocR8WCRk1DwACU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d26fbfbd-4289-4d7e-a156-44c39e9db7f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Lincoln Christian School",
      "poi_type": "Education",
      "poi_address": "1003 N 129th E Ave, Tulsa, OK 74116, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-28d2-7050-8496-e13efe76223e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-28d2-7050-8496-e13efe76223e",
        "storage_key": "property/6767906449167043/019d7917-28d2-7050-8496-e13efe76223e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lincolnchristianschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=19585184237007842&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lincoln-christian-school",
      "poi_latitude": "36.1679707",
      "poi_longitude": "-95.8301783",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-828-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b545-704e-b0a5-3abdb0ea1e89",
        "storage_key": "property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvT__rp_ztocR4rNODZ-URQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_da180c5d-f613-40ba-baf5-a0486da9eea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-3365-70b9-bcd4-f15b0fb29ca8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3365-70b9-bcd4-f15b0fb29ca8",
        "storage_key": "property/6767906449167043/019d7917-3365-70b9-bcd4-f15b0fb29ca8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 14 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b545-704e-b0a5-3abdb0ea1e89",
        "storage_key": "property/6767906449167043/019cfb52-b545-704e-b0a5-3abdb0ea1e89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a7eb658c-90f0-4ec8-b2f3-3e1b3a205aef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Oklahoma Joe's Barbecue & Catering - Catoosa",
      "poi_type": "Restaurants",
      "poi_address": "19361 Robson Rd, Catoosa, OK 74015, USA",
      "poi_short_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, and ribs, with many raving about the onion rings. They also highlight the friendly staff and the clean, comfortable atmosphere.\n\nSome reviews mention the brisket can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-3a33-732d-ba42-316e8bf0f63a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3a33-732d-ba42-316e8bf0f63a",
        "storage_key": "property/6767906449167043/019d7917-3a33-732d-ba42-316e8bf0f63a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://okjoes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4232153445449469696&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-joe-s-barbecue-catering-catoosa",
      "poi_latitude": "36.1659599",
      "poi_longitude": "-95.7608265",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-739-4757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b575-7614-84d4-f662df16a3cb",
        "storage_key": "property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-X5egj1tocRAA_2viKhuzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_95bc98ef-d496-40cf-87dc-5f5c9ebe000a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1301 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious fettuccine alfredo and bread sticks. They also highlight the friendly staff and attentive service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-399d-767f-9052-be6b43c48c03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-399d-767f-9052-be6b43c48c03",
        "storage_key": "property/6767906449167043/019d7917-399d-767f-9052-be6b43c48c03.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/broken-arrow/broken-arrow/1812?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:broken-arrow-ok-1812_pl:locurl_rd:1657",
      "poi_directions_map_url": "https://maps.google.com/?cid=5471937596139504696&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.064343",
      "poi_longitude": "-95.775177",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-2738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b575-7614-84d4-f662df16a3cb",
        "storage_key": "property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-L3eLSLtocROAQAi0A68Es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_72fbf52d-9207-43d0-a6bd-764e0a9572a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1101 N 20th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves delicious burgers, steaks, and the triple dipper appetizer. They also highlight the friendly and attentive service, and the clean atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-4278-76f6-94bb-56815331c4ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4278-76f6-94bb-56815331c4ae",
        "storage_key": "property/6767906449167043/019d7917-4278-76f6-94bb-56815331c4ae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/oklahoma/broken-arrow/broken-arrow?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=2743224776663522942&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "36.06155",
      "poi_longitude": "-95.764859",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-355-9456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b575-7614-84d4-f662df16a3cb",
        "storage_key": "property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbzYu0mKtocRfl4UcGbkESY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2bc22fab-1324-4ad8-a868-151837bff344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Cheri Ann's Trattoria",
      "poi_type": "Restaurants",
      "poi_address": "423 N Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Casual trattoria serving Italian comfort food such as pasta and chicken marsala.",
      "poi_long_description": "People say this Italian restaurant serves delicious, freshly made dishes, including ravioli, chicken Marsala, and chicken Parmesan. They highlight the generous portions, good value, and cozy, intimate atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-4294-732e-a36f-75e2ea644e96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4294-732e-a36f-75e2ea644e96",
        "storage_key": "property/6767906449167043/019d7917-4294-732e-a36f-75e2ea644e96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/pages/category/Restaurant/Cheri-Anns-Trattoria-2101982743163865/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7129883296326993471&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cheri-ann-s-trattoria",
      "poi_latitude": "36.0561924",
      "poi_longitude": "-95.7905236",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-251-0221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b575-7614-84d4-f662df16a3cb",
        "storage_key": "property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXh3a5CLtocRP8aPDxVv8mI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_964c40b5-2ff8-4964-b0cd-3fb7a0be9934",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "4651 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "People say this seafood restaurant serves delicious Bang Bang shrimp, Imperial Cod, and Brussels sprouts. They highlight the excellent service, welcoming atmosphere, and tasty complimentary bread. They also like the attentive staff and the perfect music for the occasion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-4b07-71dc-8a23-e6ce04c60573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4b07-71dc-8a23-e6ce04c60573",
        "storage_key": "property/6767906449167043/019d7917-4b07-71dc-8a23-e6ce04c60573.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/oklahoma/broken-arrow/4651-w.-kenosha-street?y_source=1_MTU1MDI2OTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058823268018440839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.059982",
      "poi_longitude": "-95.8478642",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-252-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b575-7614-84d4-f662df16a3cb",
        "storage_key": "property/6767906449167043/019cfb52-b575-7614-84d4-f662df16a3cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wz1zUiMtocRh0oQjCvVeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a4789252-a32c-498b-93c2-82b189be55d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "1907 | Oklahoma Mercantile & Eatery",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 E Fort Worth St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Apparel, gifts, and home goods with Oklahoma themes, plus custom embroidery and laser engraving.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-4f9f-712e-8ec0-2512edb8eeab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4f9f-712e-8ec0-2512edb8eeab",
        "storage_key": "property/6767906449167043/019d7917-4f9f-712e-8ec0-2512edb8eeab.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.1907ok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295512606516694759&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "1907-oklahoma-mercantile-eatery",
      "poi_latitude": "36.048033",
      "poi_longitude": "-95.7897266",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-806-8579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e67138a1dfc8",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH62tN8KLtocR587P9Q_ePmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_3fccdf39-129d-447f-aa68-a794c1057d04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Meadow Heights Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "S Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-51b1-732a-bdda-ae9db956a8e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-51b1-732a-bdda-ae9db956a8e3",
        "storage_key": "property/6767906449167043/019d7917-51b1-732a-bdda-ae9db956a8e3.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8072629761296492171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meadow-heights-shopping-center",
      "poi_latitude": "36.0474539",
      "poi_longitude": "-95.79789540000002",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e67138a1dfc8",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ__-_qOiLtocRi-ZSTf-9B3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fef39f54-f3e0-4cc9-b9bc-079760348371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1150 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the friendly and helpful service, and the clean and organized store.\n\nOther reviews mention the pickup service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-5797-76ce-b2ba-90c2c6200a87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5797-76ce-b2ba-90c2c6200a87",
        "storage_key": "property/6767906449167043/019d7917-5797-76ce-b2ba-90c2c6200a87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/broken-arrow/2422",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603451760596788981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0670278",
      "poi_longitude": "-95.7765664",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-615-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e67138a1dfc8",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjSo4zLOLtocR9abs_ADiqco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0f981a7e-e54d-4b61-8af4-ab61fbe945a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Bass Pro Drive, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of hunting, fishing, and outdoor gear, as well as clothing and home decor. They highlight the fun and festive atmosphere, especially during the holidays, and the interesting attractions like the fish tanks and trout pond. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-5589-7109-a64d-df8876c0b873.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5589-7109-a64d-df8876c0b873",
        "storage_key": "property/6767906449167043/019d7917-5589-7109-a64d-df8876c0b873.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/ok/broken-arrow/101-bass-pro-dr.html?y_source=1_MzAxMTUyNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650999968817088325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "36.0709381",
      "poi_longitude": "-95.7921204",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-355-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e67138a1dfc8",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhSZm66KLtocRRQea6djOUss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_f478ef53-7043-45f5-bfe3-e7241bf17c07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1300 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Friendly neighborhood establishment for everything from fresh produce to toys and electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-5bf9-77a8-8604-4ae91083680a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5bf9-77a8-8604-4ae91083680a",
        "storage_key": "property/6767906449167043/019d7917-5bf9-77a8-8604-4ae91083680a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/4655-broken-arrow-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1291450374524807913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.07620310000001",
      "poi_longitude": "-95.7759056",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-505-6247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b546-7671-a65d-53b1f2b77e67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b546-7671-a65d-53b1f2b77e67",
        "storage_key": "property/6767906449167043/019cfb52-b546-7671-a65d-53b1f2b77e67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ_cjauLtocR6aqY8kUn7BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_da64fb48-2389-4817-8c34-29c5d0c50a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "851 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy, organic, and allergy-friendly foods, including fresh produce and a variety of spices. They also highlight the clean and well-organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-5a7b-74c2-80fa-2b700ddc443d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5a7b-74c2-80fa-2b700ddc443d",
        "storage_key": "property/6767906449167043/019d7917-5a7b-74c2-80fa-2b700ddc443d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/ok/broken-arrow/broken-arrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=15446441561898677919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.0670665",
      "poi_longitude": "-95.7812788",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-806-0810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b546-7671-a65d-53b1f2b77e67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b546-7671-a65d-53b1f2b77e67",
        "storage_key": "property/6767906449167043/019cfb52-b546-7671-a65d-53b1f2b77e67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdP2WLCLtocRn_bMBMPIXNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a0d501a1-3db4-4ea2-9b23-a1fef0359594",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "751 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide selection of hobby supplies, decorations, and crafts, especially for Christmas. They highlight the great deals, clean and orderly layout, and fast checkout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-6223-7648-9d2c-2587d3f8faa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6223-7648-9d2c-2587d3f8faa0",
        "storage_key": "property/6767906449167043/019d7917-6223-7648-9d2c-2587d3f8faa0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/109",
      "poi_directions_map_url": "https://maps.google.com/?cid=6443544312498990052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "36.067207",
      "poi_longitude": "-95.7834025",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-355-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e67138a1dfc8",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4-DYNEGJtocR5Kv9sGkRbFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3099d6f8-cad0-416e-9de8-50ea9c4d09e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1620 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-6374-731b-975e-fde0b8c9ec2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6374-731b-975e-fde0b8c9ec2b",
        "storage_key": "property/6767906449167043/019d7917-6374-731b-975e-fde0b8c9ec2b.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ok/broken-arrow/1022/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=13695511384189247231&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dick-s-sporting-goods",
      "poi_latitude": "36.0658949",
      "poi_longitude": "-95.7719558",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-3310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e67138a1dfc8",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e67138a1dfc8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQwcmekuKtocR_x7rvwo7EL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_1bb406a9-f2e9-4700-9f81-cfc4a2a85d16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Cinemark Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "1801 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies, including 3D options. They also highlight the reasonable ticket prices, clean facilities, and friendly, helpful staff.\n\nOther reviews mention the seats can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-65df-7545-8e49-11e243ab052d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-65df-7545-8e49-11e243ab052d",
        "storage_key": "property/6767906449167043/019d7917-65df-7545-8e49-11e243ab052d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ok-broken-arrow/cinemark-broken-arrow?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxMTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7062085401556035336&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-broken-arrow",
      "poi_latitude": "36.0633908",
      "poi_longitude": "-95.7706171",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-0427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b557-744b-87ea-834415a534c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b557-744b-87ea-834415a534c0",
        "storage_key": "property/6767906449167043/019cfb52-b557-744b-87ea-834415a534c0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_qPa0uKtocRCCc4lUGRAWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0e626d80-8155-4be0-b3a1-8bf455cb77ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Broken Arrow Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "701 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary 1,500-seat venue hosting an array of shows, including Broadway tours & pop concerts.",
      "poi_long_description": "People say this performing arts theater offers a nice selection of music and passionate performances in an intimate setting. They highlight the beautiful venue, great sound, and accessible seating, as well as the clean and well-organized facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-65e1-748a-904a-f918b3d0c9be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-65e1-748a-904a-f918b3d0c9be",
        "storage_key": "property/6767906449167043/019d7917-65e1-748a-904a-f918b3d0c9be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.brokenarrowpac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1015494257798968490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-performing-arts-center",
      "poi_latitude": "36.04614979999999",
      "poi_longitude": "-95.7900528",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-259-5778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e0352387d342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e0352387d342",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e0352387d342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9lh4dyLtocRqnSOq6XCFw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2ad872cd-4092-434d-adc0-40db1c4e65b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Broken Arrow Roller Sports",
      "poi_type": "Entertainment",
      "poi_address": "551 W Oakland Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Clean roller rink, offering skate rentals, for parties, open skate sessions and more.",
      "poi_long_description": "People say this roller skating rink offers a fun and nostalgic experience with a large skating rink, arcade games, and affordable concessions. They also highlight the great music, old-school charm, and the accommodating and helpful staff.\n\nSome reviews mention the skates can be old.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-6cf9-73ba-bdfd-48c4ce7b0acc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6cf9-73ba-bdfd-48c4ce7b0acc",
        "storage_key": "property/6767906449167043/019d7917-6cf9-73ba-bdfd-48c4ce7b0acc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowrollersports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1678649607122851130&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-roller-sports",
      "poi_latitude": "36.0676436",
      "poi_longitude": "-95.7953821",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-251-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e0352387d342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e0352387d342",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e0352387d342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQ7CdpeLtocROhXofuzCSxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_744a701e-fc34-49f6-a5bd-d677605ac4e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Action Lounge",
      "poi_type": "Entertainment",
      "poi_address": "832 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Laid-back spot for beer, billiards and karaoke, plus darts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-6d2d-7342-b0d2-7f0454902e22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6d2d-7342-b0d2-7f0454902e22",
        "storage_key": "property/6767906449167043/019d7917-6d2d-7342-b0d2-7f0454902e22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://m.facebook.com/pages/category/Pub/Debs-Action-Lounge-148115542370/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6588400454975118032&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "action-lounge",
      "poi_latitude": "36.0449015",
      "poi_longitude": "-95.8171957",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-258-1773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-79ff-7179-a1a2-5db5bfc057ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7917-79ff-7179-a1a2-5db5bfc057ef",
        "storage_key": "property/6767906449167043/019d7917-79ff-7179-a1a2-5db5bfc057ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJATS1lAeMtocR0FrQlE6zbls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_8b1afed3-710d-41f9-8ea1-f1f23698f6f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Lumberjack Attack Axe Throwing",
      "poi_type": "Entertainment",
      "poi_address": "3812 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Game lounge featuring lanes for throwing axes at targets and a lounge, as well as escape rooms.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019d7917-7218-745f-a785-7944af6be2de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-7218-745f-a785-7944af6be2de",
        "storage_key": "property/6767906449167043/019d7917-7218-745f-a785-7944af6be2de.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lumberjackattackaxe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15428565119382083105&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lumberjack-attack-axe-throwing",
      "poi_latitude": "36.0143435",
      "poi_longitude": "-95.7992576",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-515-0460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-b556-76ec-bc7d-e0352387d342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-b556-76ec-bc7d-e0352387d342",
        "storage_key": "property/6767906449167043/019cfb52-b556-76ec-bc7d-e0352387d342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe90SjzWJtocRIVbAZjtGHdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_5be25e6f-fd0c-4908-80f1-c09a8297cb70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "poi_name": "Shiloh’s",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "shiloh-s",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_392bb189d1cade5bb3a5457b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f09036f806d2d4386638f19d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c1108aaf76be2e8428a71830",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ccb9c8dca3f8939da33df97f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_7f0288f0f7984af9656d0539",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_cf8071d3a8d563b98338c353",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_b60298bb-b980-4557-80b2-0f236c2237fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "rating": "5.0",
      "name": "Marcia Burnett",
      "text": "My southeast facing apartment/balcony is perfectly situated overlooking the pond, which makes me feel like I’m living in a vacation resort. The staff are very friendly, helpful, and prompt to address maintenance issues, the grounds are kept clean and well manicured, and my neighbors are friendly and quiet. I recommend the complex to anyone looking for a positive apartment-living experience.",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_95c64b33-02b2-48de-abb6-31e5f0db1177",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "rating": "5.0",
      "name": "Janice Smith",
      "text": "It's home! Only instead of having all the maintenance and expence of owing a home, you'll have experts taking care of everything for you.  They even offer free wood for your fireplace in winter. Lots of great people and great friends. I love it!",
      "date": "2025-11-28",
      "title": ""
    },
    {
      "id": "custom_31a144dc-48ed-4ce5-b4e4-6c0c506cd004",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "rating": "5.0",
      "name": "Sherry Wright",
      "text": "I did a lot of research on apartments in Broken Arrow and The Park at Mission Hills had the best reviews so here I am! Matt & Madeline and the whole staff are great and always very helpful and maintenance is great as well!  I feel very safe living here and cannot beat the location! Moved in last June and don’t plan leaving anytime soon or ever!",
      "date": "2025-01-04",
      "title": ""
    },
    {
      "id": "custom_d4592aca-62c6-457f-a908-e437c772a2a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "rating": "5.0",
      "name": "Alba Diaz",
      "text": "When dealing with the worst apartment's flooding in my place, I couldn't imagine it! BUT, it happened.  Called the manager, related the issue happening in my place, and my goodness! It looks like the whole crew was there within 2-3 minutes plus the manager Brittany! What a good job they all did. Excellent job, I am truly impressed how they treated my belongings with respect and care, I  do give them my biggest thanks and gratefully thank you, from an eldest lady! Michael thanks for all your knowledge and professionalism, see ya around!",
      "date": "2025-10-08",
      "title": ""
    },
    {
      "id": "custom_f0a6c0d6-d527-4011-a9e8-7df400e1e6e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "rating": "5.0",
      "name": "Amee Anderson",
      "text": "We love Park at Mission Hills but the part we love the best is the incredible staff🥰, from the time we did a walk through, all our communications, having things already for us.  We had such a great experience and continue to with our Dear Friend Cody and so many others of the staff to include the grounds keepers.\nA quiet, well kept place - out little Shangri-La!",
      "date": "2026-01-21",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_49feda75-1e6e-4bdc-97ab-3e9799eccf32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb53-4357-707f-94fb-db978082c714.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of a swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019cfb53-4357-707f-94fb-db978082c714",
        "storage_key": "property/6767906449167043/019cfb53-4357-707f-94fb-db978082c714.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Park at Mission Hills Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff8fa6a8d3aa60094c2bb4"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-4b8f-705d-8c8b-0532eb81fc37",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "park-at-mission-hills",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043"
    },
    {
      "lead_collector_id": "019cf79e-4c05-7544-a118-fba09e2b3cbe",
      "lead_source": "LANDING_PAGE",
      "name": "park-at-mission-hills",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-broken-arrow-ok",
      "search_query": "pet friendly apartments in Broken Arrow OK",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Broken Arrow, OK",
      "h2_subtitle": "Discover pet welcoming homes at Park at Mission Hills. Enjoy a community perfect for you and your pet in Broken Arrow, OK.",
      "page_copy": "Park at Mission Hills offers ideal pet friendly apartments in Broken Arrow, OK. Our community boasts a pet-friendly environment designed to make both you and your furry friends feel at home. Relax by the pond, or enjoy the expansive spaces throughout our community with your pet by your side.\n\nBeyond being a perfect home for pet lovers, Park at Mission Hills features premium amenities like a grill & chill area by the pool, vaulted ceilings, and central heat and air conditioning. Our location in Broken Arrow, OK provides convenience and comfort in a welcoming community. Experience the blend of modern living with pet-friendly access at our vibrant property.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Broken Arrow, OK",
      "seo_description": "Find pet friendly apartments in Broken Arrow, OK at Park at Mission Hills. Enjoy a welcoming community for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-with-dog-park-tulsa-county",
      "search_query": "apartments with dog park in Tulsa County",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park in Tulsa County",
      "h2_subtitle": "Find the perfect home at Park at Mission Hills. Enjoy amenities that include a welcoming environment for you and your dog in Tulsa County.",
      "page_copy": "At Park at Mission Hills, we understand the importance of having a welcoming space for both residents and their canine companions. While we don't have a traditional dog park onsite, our community is set in a spacious, pet-friendly environment in Tulsa County where pets can comfortably enjoy their outdoor time. The surrounding area in Broken Arrow provides ample room for daily walks and play, making it an ideal choice for pet owners.\n\nOur community thrives on providing a pleasant living experience with amenities like vaulted ceilings, a relaxing pond, and a grill & chill area by the pool. Additionally, our central location in Tulsa County ensures you're never far from local parks and recreational areas that offer further adventure opportunities for you and your dog. Join us at Park at Mission Hills and experience a community tailored for you and your beloved pets.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Park Access in Tulsa County",
      "seo_description": "Find apartments near dog parks in Tulsa County at Park at Mission Hills. Enjoy pet-friendly living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-74012",
      "search_query": "energy efficient apartments in 74012",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in 74012",
      "h2_subtitle": "Discover energy-saving features at Park at Mission Hills. Live in comfort and efficiency right here in Broken Arrow, zip code 74012.",
      "page_copy": "Park at Mission Hills is proud to offer energy efficient apartments in the heart of Broken Arrow's 74012 area. With thoughtful design and modern amenities, our community provides comfortable living while minimizing energy consumption. Each apartment is equipped with central heat and air conditioning systems that are optimized for efficiency, ensuring that your home stays comfortable year-round without racking up high utility bills.\n\nBeyond energy efficiency, residents enjoy a range of top-notch amenities, including vaulted ceilings and a microwave in every unit, which contribute to the ease and quality of daily living. The grill & chill area by the pool is another inviting feature where you can relax while enjoying the natural surroundings of our community. Choose Park at Mission Hills for a smart, efficient lifestyle in a vibrant location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments in 74012",
      "seo_description": "Explore energy efficient apartments in 74012 at Park at Mission Hills. Enjoy smart living with energy-saving features and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-with-central-air-conditioning-broken-arrow",
      "search_query": "apartments with central air conditioning in Broken Arrow",
      "category": "Amenity",
      "h1_title": "Apartments with Central Air in Broken Arrow",
      "h2_subtitle": "Experience comfort with central air conditioning at Park at Mission Hills, perfectly situated in Broken Arrow.",
      "page_copy": "At Park at Mission Hills, each apartment is designed with your comfort in mind, featuring central air conditioning as a standard amenity. Located in the heart of Broken Arrow, our community offers a perfect blend of convenience and comfort, ensuring a pleasurable living experience throughout the year. Whether it's the heat of summer or the chill of winter, our central air system keeps your home climate perfectly regulated.\n\nApart from central air conditioning, our apartments boast additional features like vaulted ceilings and a relaxing pond, creating a serene and modern living environment. Residents can also enjoy amenities such as a grill & chill area by the pool and a convenient microwave in each kitchen. Discover the charm and comfort of living at Park at Mission Hills, where quality living meets optimal climate control.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Central Air in Broken Arrow",
      "seo_description": "Discover apartments with central air conditioning in Broken Arrow at Park at Mission Hills. Comfort and convenience are our priorities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "washer-dryer-connections-apartments-broken-arrow-ok",
      "search_query": "washer dryer connections apartments in Broken Arrow OK",
      "category": "Amenity",
      "h1_title": "Washer Dryer Connections in Broken Arrow",
      "h2_subtitle": "Find apartments with washer dryer connections at Park at Mission Hills. Enjoy modern conveniences in Broken Arrow, OK.",
      "page_copy": "Park at Mission Hills stands out in Broken Arrow, OK as a community that prioritizes your convenience and lifestyle. While we don't have washer dryer connections, we offer a suite of amenities designed to enhance daily living. Each apartment comes equipped with central heat and air conditioning, making it a comfortable retreat year-round.\n\nAdditionally, our property includes exceptional features like vaulted ceilings and a relaxing pond, providing a serene setting to call home. For social gatherings, the grill & chill area by the pool is perfect for entertaining friends and family. Located in the vibrant heart of Broken Arrow, our community ensures you're close to all local shops and attractions, making it a convenient choice for modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Connections in Broken Arrow, OK",
      "seo_description": "Explore Broken Arrow, OK apartments at Park at Mission Hills. Enjoy modern amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-broken-arrow-ok",
      "search_query": "two bedroom apartments broken arrow ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Broken Arrow, OK",
      "h2_subtitle": "Discover spacious two bedroom apartments at Park at Mission Hills, located in the thriving community of Broken Arrow, OK.",
      "page_copy": "Explore the comfort and convenience of two bedroom apartments at Park at Mission Hills, ideally situated in Broken Arrow, OK. Our spacious floor plans are designed to meet the needs of modern living, offering ample space for relaxation and entertainment. Each apartment is well-equipped with central heat and air conditioning, ensuring a comfortable home environment throughout all seasons.\n\nIn addition to generous living spaces, our community offers a range of amenities that enrich your lifestyle. Enjoy the stunning vaulted ceilings that add a touch of elegance to your home. Spend quality time with friends at our grill & chill area by the pool, or take a leisurely stroll around our relaxing pond. Park at Mission Hills combines superb amenities with an unbeatable location in Broken Arrow, making it the perfect choice for your next home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Broken Arrow, OK",
      "seo_description": "Find spacious two-bedroom apartments in Broken Arrow, OK at Park at Mission Hills. Enjoy modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-tulsa-county",
      "search_query": "one bedroom apartments tulsa county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tulsa County",
      "h2_subtitle": "Discover stylish one bedroom apartments at Park at Mission Hills, perfectly located in Tulsa County.",
      "page_copy": "At Park at Mission Hills, find the ideal one bedroom apartment in Tulsa County that blends comfort with style. Our apartments are thoughtfully designed to provide a cozy and functional living space, perfect for singles or those seeking an uncomplicated lifestyle. Each unit is equipped with central heat and air conditioning, ensuring a pleasant atmosphere whatever the season.\n\nOur community is rich with amenities that enhance your living experience. Unwind in the grill & chill area by the pool or enjoy the tranquil surroundings offered by our relaxing pond. With vaulted ceilings adding a sense of spaciousness, and convenient features like microwaves, our apartments offer everything you need and more. Nestled in the welcoming community of Broken Arrow, discover the convenience of being close to local amenities and services while enjoying the serenity of our beautiful community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Tulsa County",
      "seo_description": "Explore one bedroom apartments in Tulsa County at Park at Mission Hills. Enjoy modern amenities in a scenic community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-near-tulsa-community-college-se-campus",
      "search_query": "apartments near Tulsa Community College Southeast Campus",
      "category": "School",
      "h1_title": "Apartments Near Tulsa Community College SE Campus",
      "h2_subtitle": "Find your new home at Park at Mission Hills, conveniently located near Tulsa Community College's Southeast Campus.",
      "page_copy": "Located just a short drive from Tulsa Community College's Southeast Campus, Park at Mission Hills offers a perfect blend of comfort and convenience. Ideal for students, faculty, and professionals alike, our community provides easy access to all the resources and opportunities that the college offers. Each of our apartments is equipped with modern amenities such as central heat and air conditioning and a microwave, ensuring a hassle-free living experience.\n\nOur community also boasts fantastic features like vaulted ceilings and a tranquil relaxing pond, creating an inviting atmosphere both inside and out. The grill & chill area by our pool is perfect for unwinding after a day at college or work. Reside in a location that connects you with educational pursuits and the vibrant activities of Broken Arrow, while enjoying a peaceful retreat at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tulsa Community College SE Campus",
      "seo_description": "Discover Park at Mission Hills, close to Tulsa Community College SE Campus. Enjoy modern living and easy commutes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-by-northeastern-state-university-ba",
      "search_query": "apartments by Northeastern State University Broken Arrow, OK",
      "category": "School",
      "h1_title": "Apartments by Northeastern State University BA",
      "h2_subtitle": "Park at Mission Hills offers ideal living near Northeastern State University, Broken Arrow, OK.",
      "page_copy": "For students and faculty seeking prime housing near Northeastern State University, Broken Arrow, look no further than Park at Mission Hills. Our convenient location makes commuting to classes a breeze, allowing you more time to focus on your studies or unwind after a long day. Our apartment homes provide all the comforts you need, featuring amenities such as central heat and air conditioning and a microwave.\n\nApart from the convenience to the university, our community enhances your living experience with exceptional amenities. Enjoy the peaceful ambiance of our relaxing pond or entertain friends at the grill & chill area by the pool. With vaulted ceilings adding a sophisticated touch, our units cater to both relaxation and an active lifestyle. Embrace the best of apartment living at Park at Mission Hills, where education and leisure perfectly converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Northeastern State University BA",
      "seo_description": "Live near Northeastern State University, BA at Park at Mission Hills. Enjoy a vibrant living environment with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-south-tulsa",
      "search_query": "apartments near saint francis hospital south tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital South Tulsa",
      "h2_subtitle": "Discover the convenience of living close to Saint Francis Hospital South. Park at Mission Hills offers ideal apartments for healthcare professionals and others.",
      "page_copy": "If you're seeking a home near Saint Francis Hospital South, Tulsa, Park at Mission Hills is the perfect choice. Our community is situated just a short drive from the hospital, making it ideal for healthcare professionals and anyone who values proximity to medical facilities. Our apartments are designed with your comfort in mind, featuring amenities like central heat and air conditioning and in-unit microwaves.\n\nResidents benefit not only from our convenient location but also from a variety of on-site amenities that enhance everyday living. Spend your downtime enjoying the relaxing pond or host a barbecue at our grill & chill area by the pool. Vaulted ceilings provide an airy, spacious feel that enhances your home living. Experience the blend of convenience and tranquility that Park at Mission Hills offers, nestled in the welcoming community of Broken Arrow.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital South Tulsa",
      "seo_description": "Find apartments near Saint Francis Hospital South at Park at Mission Hills. Perfect for healthcare professionals seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "broken-arrow-apartments-near-council-oak-healthcare",
      "search_query": "broken arrow apartments close to council oak comprehensive healthcare",
      "category": "Hospital",
      "h1_title": "Broken Arrow Apartments Close to Council Oak Healthcare",
      "h2_subtitle": "Park at Mission Hills offers comfortable living near Council Oak Comprehensive Healthcare. Perfect for professionals and individuals seeking proximity and convenience.",
      "page_copy": "For those working at or requiring frequent visits to Council Oak Comprehensive Healthcare, Park at Mission Hills provides the perfect living solution. Our Broken Arrow apartments are strategically located to offer you quick and convenient access, making your daily commute effortless. Enjoy amenities designed to enhance your lifestyle, including central heat and air conditioning and a handy microwave in each unit.\n\nOur community is not just about convenience; it’s about living well. From a serene pond that invites relaxation to vaulted ceilings that expand your living space, our amenities cater to diverse needs. The grill & chill area by the pool is ideal for weekend gatherings or a peaceful evening under the stars. Discover the ideal blend of proximity and peaceful living at Park at Mission Hills, where quality and convenience meet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Broken Arrow Apartments Close to Council Oak Healthcare",
      "seo_description": "Live near Council Oak Healthcare at Park at Mission Hills. Perfect for professionals seeking comfortable and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-broken-arrow",
      "search_query": "apartments near Rhema Park Broken Arrow",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park, Broken Arrow",
      "h2_subtitle": "Park at Mission Hills offers ideal living close to Rhema Park. Enjoy nature and vibrant community life in Broken Arrow.",
      "page_copy": "For those who cherish outdoor living and a vibrant community, Park at Mission Hills is ideally situated near Rhema Park in Broken Arrow. Our apartments offer a perfect home base for enjoying the scenic beauty and recreational opportunities that Rhema Park provides while keeping you close to the city's conveniences. Each apartment features essential amenities such as central heat and air conditioning and a microwave.\n\nLiving at Park at Mission Hills also means access to top-notch community amenities. Imagine spending sunny afternoons by the relaxing pond or hosting friends at our grill & chill area by the pool. The spaciousness afforded by our vaulted ceilings complements the inviting atmosphere. Make the most of living near Rhema Park, where you can relish both tranquility and community activities every day.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park, Broken Arrow",
      "seo_description": "Live near Rhema Park at Park at Mission Hills. Perfect for nature lovers seeking comfort and community life in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-near-elam-park-74012",
      "search_query": "apartments by Elam Park 74012",
      "category": "Park",
      "h1_title": "Apartments by Elam Park 74012",
      "h2_subtitle": "Explore living at Park at Mission Hills near Elam Park in the 74012 area. Enjoy a serene environment with all the conveniences you need close at hand.",
      "page_copy": "Discover your new home at Park at Mission Hills, conveniently located near Elam Park in the 74012 ZIP code. This area offers a blend of natural beauty and urban convenience, making it an attractive choice for those looking for tranquility without sacrificing access to local amenities. Our community provides comfortable apartments equipped with central heat and air conditioning, complemented by practical in-unit features like a microwave.\n\nEnjoy the community vibe with amenities that enhance your leisure time, such as a relaxing pond perfect for unwinding and a grill & chill area by the pool for hosting friends. The vaulted ceilings add an elegant touch to your living space, creating an airy feel that enhances relaxation. Choose Park at Mission Hills and embrace the perfect living environment near Elam Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Elam Park 74012",
      "seo_description": "Find comfort at Park at Mission Hills near Elam Park in 74012. Enjoy community living with great amenities and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-near-jackson-park-tulsa-county",
      "search_query": "apartments close to Jackson Park Tulsa County",
      "category": "Park",
      "h1_title": "Apartments Close to Jackson Park in Tulsa County",
      "h2_subtitle": "Park at Mission Hills offers prime living near Jackson Park, Tulsa County. Enjoy the blend of community life and nature.",
      "page_copy": "Park at Mission Hills presents an exceptional living opportunity close to Jackson Park in Tulsa County. Ideal for those who appreciate outdoor spaces, our apartments provide the convenience of being near one of the area’s cherished green spaces. Residents enjoy easy access to the park and all the recreational activities it offers. Our apartments are thoughtfully designed with features such as central heat and air conditioning, ensuring year-round comfort, along with a microwave for added convenience.\n\nOur community amenities elevate your lifestyle, providing a relaxing pond to unwind by after a long day and a grill & chill area by the pool, perfect for hosting social gatherings. The vaulted ceilings in each apartment contribute to a spacious and open atmosphere. Choose Park at Mission Hills for a fulfilling lifestyle next to Jackson Park in Tulsa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Jackson Park in Tulsa County",
      "seo_description": "Live near Jackson Park at Park at Mission Hills. Ideal location with great amenities for outdoor enthusiasts in Tulsa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167043",
      "source": "generator",
      "page_item_url": "apartments-near-mccullough-park-ok",
      "search_query": "apartments near McCullough Park OK",
      "category": "Park",
      "h1_title": "Apartments Near McCullough Park, OK",
      "h2_subtitle": "Experience life at Park at Mission Hills, conveniently located near McCullough Park, OK. Enjoy serenity and community living.",
      "page_copy": "Nestled close to McCullough Park, Park at Mission Hills offers a serene living environment in OK. Our location is perfect for those who treasure outdoor spaces and desire quick access to park facilities. Each apartment is designed with comfort in mind, offering amenities like central heat and air conditioning together with in-unit conveniences like a microwave.\n\nPark at Mission Hills enhances your living experience with community features that include a relaxing pond, ideal for peaceful reflection, and a grill & chill area by the pool, perfect for socializing with family and friends. The vaulted ceilings provide a spacious and open feel that complements the tranquil setting. Make Park at Mission Hills your home and enjoy the benefits of living close to McCullough Park in OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McCullough Park, OK",
      "seo_description": "Explore Park at Mission Hills near McCullough Park. Enjoy peaceful living with excellent amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5192"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-ETMMF9B5G3"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151568"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/park-at-mission-hills/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T4NBR7VF"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167043/019d1bd8-ff3f-73ff-9405-561a71cc3a06.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "39355ab7-0b71-40fc-832e-475400f8e51b"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-629-6410"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651dc11a9e52c90f3c1012"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkQ5YWJDZVkxampQeE5MVmEyMDVmaFE9PSIsInZhbHVlIjoiNmJPRXdmZVdZeUd6M3JhS2pJSkFlUT09IiwibWFjIjoiZDJhZTBhZWUyZDM1Y2YxZDYyZTM3NGE2NGFkMDQ1NzFjYjQ5MGY5ZGQxOThhMDEzM2E2ZjIyYzBkOGQxZDIyOCJ9"
    }
  ],
  "custom_qb_id": "5192",
  "custom_ga4_id": "G-ETMMF9B5G3",
  "custom_repli_id": "10041151568",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/park-at-mission-hills/register/",
  "custom_google_gtm_id": "GTM-T4NBR7VF",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167043/019d1bd8-ff3f-73ff-9405-561a71cc3a06.pdf",
  "custom_rentgrata_property_id": "39355ab7-0b71-40fc-832e-475400f8e51b",
  "custom_ppc_tracking_phone_number": "844-629-6410",
  "custom_residentboost_apartment_id": "64651dc11a9e52c90f3c1012",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkQ5YWJDZVkxampQeE5MVmEyMDVmaFE9PSIsInZhbHVlIjoiNmJPRXdmZVdZeUd6M3JhS2pJSkFlUT09IiwibWFjIjoiZDJhZTBhZWUyZDM1Y2YxZDYyZTM3NGE2NGFkMDQ1NzFjYjQ5MGY5ZGQxOThhMDEzM2E2ZjIyYzBkOGQxZDIyOCJ9"
};

export const generatedAt = '2026-08-27T21:33:06.051Z';
